export const TooltipPriceImpact = () => {
  return <>The estimated difference between USD values of input and output amounts.</>;
};
